module.exports = __webpack_public_path__ + "img/sea-3.3e114429.jpg";